import { useState } from "react";
import {
  acceptTracking,
  declineTracking,
  getTrackingConsent,
} from "@/lib/analytics";

export const CookieConsentBanner = ({ onChoice }) => {
  const [choice, setChoice] = useState(getTrackingConsent());

  if (choice !== "unknown") {
    return null;
  }

  const accept = () => {
    acceptTracking();
    setChoice("accepted");
    onChoice?.("accepted");
  };

  const decline = () => {
    declineTracking();
    setChoice("declined");
    onChoice?.("declined");
  };

  return (
    <aside
      className={[
        "fixed inset-x-4 bottom-4 z-[70] mx-auto max-w-2xl border border-[#D6D0C7]",
        "bg-[#FFFCF7] p-4 shadow-xl sm:bottom-6 sm:flex sm:items-center",
        "sm:justify-between sm:gap-6",
      ].join(" ")}
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-consent-banner"
    >
      <p
        className="text-sm font-medium text-[#1E2A24]"
        data-testid="cookie-consent-message"
      >
        We use cookies to improve your experience.
      </p>
      <div className="mt-3 flex gap-2 sm:mt-0">
        <button
          type="button"
          onClick={decline}
          className={[
            "rounded-lg border border-[#B8B1A7] px-4 py-2 text-sm font-semibold",
            "text-[#3C453E] hover:bg-[#F1EEE8]",
          ].join(" ")}
          data-testid="cookie-consent-decline"
        >
          Decline
        </button>
        <button
          type="button"
          onClick={accept}
          className={[
            "rounded-lg bg-[#2D5A47] px-4 py-2 text-sm font-semibold text-white",
            "hover:bg-[#214435]",
          ].join(" ")}
          data-testid="cookie-consent-accept"
        >
          Accept
        </button>
      </div>
    </aside>
  );
};